/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * An enumeration.
 */
export enum ApplicationArea {
  FACE = "face",
  EYES = "eyes",
  LIPS = "lips",
  NECK_AND_DECOLLETAGE = "neck_and_decolletage",
  HANDS = "hands",
  BODY = "body",
  HAIR_AND_SCALP = "hair_and_scalp",
  INTIMATE_AREAS = "intimate_areas",
  EARS = "ears",
  ORAL_CAVITY = "oral_cavity",
}
